import { services } from "../../../constants/services";
import { getByQuery } from "../../../utils/api";
import { IParamsBuilding, ResponseQ } from "../../../common/dtos/paginate.dto";

export const GetBuildingWithPaginationService = async (params: IParamsBuilding) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.rooms}/building`, params);
  return response;
};